module.exports = __webpack_public_path__ + "static/media/member-dashboard-header-bg.158ea90d.png";